import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { createPinia } from "pinia";
import RollbarPlugin from "../rollbar";
import App from "./App.vue";
import router from "./router";
import en from "./locales/en";
import de from "./locales/de";
import deInformal from "./locales/de-informal";
import uk from "./locales/uk";
import { brandName, supportEmail } from "./constants/brand";
import { applyBrandToLocaleMessages } from "./utils/applyBrandToLocaleMessages";
import { installConsoleCaptureForSupport } from "./utils/consoleCaptureForSupport";
import "../styles/_custom-bootstrap-variables.scss";
import "../styles/index.scss";
/* Booking section + recap field chrome; after index so recap overrides win over body/.disabled */
import "../styles/bookingFormSection.scss";
import "../styles/searchResultsPrint.scss";

/** When embedded, `html { min-height: 100% }` tracks the iframe height and can fight parent-driven resize (postMessage), causing a feedback loop. */
if (typeof document !== "undefined") {
  try {
    if (window.parent !== window) {
      document.documentElement.classList.add("covomo-embedded");
    }
  } catch {
    /* ignore (e.g. rare sandbox / access quirks) */
  }
}

// Prevent the browser from restoring the previous page's scrollY on SPA navigations
// (results → comparison → booking → back), which left users mid-page.
if (typeof history !== "undefined" && "scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

installConsoleCaptureForSupport();

const brandOpts = { brandName, supportEmail };

const messages = {
  de: applyBrandToLocaleMessages(de, brandOpts),
  "de-informal": applyBrandToLocaleMessages(deInformal, brandOpts),
  en: applyBrandToLocaleMessages(en, brandOpts),
  uk: applyBrandToLocaleMessages(uk, brandOpts),
};

const i18n = createI18n({
  legacy: false,
  warnHtmlMessage: false,
  locale: "de", // set locale
  fallbackLocale: "en", // set fallback locale
  messages,
});

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(RollbarPlugin)
  .mount("#app");
